import React from 'react'
import { Props } from './types'

const DefaultLoader: React.FC<Props> = props => {
  return <span id='loader' {...props} />
}

export default DefaultLoader
